module.exports = __webpack_public_path__ + "static/media/gooseText.500fe43c.png";